import RelationToOneField from '@/shared/fields/relation-to-one-field';
import ApiService from '@/shared/services/api.service';

export class FunctionTypeField {
    static relationToOne(name, label, options, filterParams) {
        return new RelationToOneField(
            name,
            label,
            () => {
                return new Promise((resolve) => {
                    ApiService.query('/functions/process-management').then(({data}) => {
                        resolve(data);
                    });
                })
            },
            (record) => {
                if (!record) {
                    return null;
                }

                return {
                    value: record.name,
                    text: record.name,
                };
            },
            options,
            filterParams,
        );
    }
}
